//backend
import { useEffect, useRef, useState } from 'react';
import '../components/PartnersSection.css';
import { apiUrl } from '../config/api';



interface Partner {
  id: number;
  image: string;
  image_url: string;
  order: number;
}



const Partners = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [partners, setPartners] = useState<Partner[]>([]);
  const [loading, setLoading] = useState(true);

  // Fetch partners
  useEffect(() => {
    fetch(apiUrl('/api/partners'))
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setPartners(data.data);
        }
      })
      .catch(err => console.error('Error:', err))
      .finally(() => setLoading(false));
  }, []);

  // Intersection Observer for fade-in animation
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Duplicate logos for seamless infinite scroll
  const allPartners = [...partners, ...partners];

  if (loading) {
    return (
      <section 
        id="our-partners" 
        ref={sectionRef}
        className="partners-section"
      >
        <div className="help p-0 m-0" style={{ paddingBottom: '20px' }}>
          <h2 className="title-animation">
            Our Partners
          </h2>
        </div>
        <p>Loading partners...</p>
      </section>
    );
  }

  if (partners.length === 0) {
    return (
      <section 
        id="our-partners" 
        ref={sectionRef}
        className="partners-section"
      >
        <div className="help p-0 m-0" style={{ paddingBottom: '20px' }}>
          <h2 className="title-animation">
            Our Partners
          </h2>
        </div>
        <p>No partners available</p>
      </section>
    );
  }

  return (
    <section 
      id="our-partners" 
      ref={sectionRef}
      className={`partners-section ${isVisible ? 'visible' : ''}`}
    >
      <div className="help p-0 m-0" style={{ paddingBottom: '20px' }}>
        <h2 className="title-animation">
          Our Partners
        </h2>
      </div>

      <div className="partners-carousel">
        <div className="partners-track">
          {allPartners.map((partner, index) => (
            <div key={`${partner.id}-${index}`} className="partner-card">
              <img 
                src={partner.image_url} 
                alt={`Partner ${partner.id}`}
                loading="lazy"
                onError={(e) => {
                  console.error('Image failed to load:', partner.image_url);
                  (e.target as HTMLImageElement).src = 'https://via.placeholder.com/160x100?text=Logo';
                }}
              />
            </div>
          ))}
        </div>
      </div>

      
    </section>
  );
};

export default Partners;

















//frontend
// // PartnersSection.tsx
// import { useEffect, useRef, useState } from 'react';
// import '../components/PartnersSection.css';


// import partner1 from '../images/partners/org_aics.png'; 
// import partner2 from '../images/partners/org_anoced.png'; 
// import partner3 from '../images/partners/org_wclrf.png'; 
// import partner4 from '../images/partners/org_top_target.jpg'; 
// import partner5 from '../images/partners/org_hadaf.jpg'; 

// interface PartnerLogo {
//   src: string;
//   alt: string;
// }
//     const Partners = () => {
//     const sectionRef = useRef<HTMLElement>(null);
//     const [isVisible, setIsVisible] = useState(false);

//     const partnerLogos: PartnerLogo[] = [
//         { src: partner1, alt: "Partner 1" },
//         { src: partner2, alt: "Partner 2" },
//         { src: partner3, alt: "Partner 3" },
//         { src: partner4, alt: "Partner 4" },
//         { src: partner5, alt: "Partner 5" },
//     ];




//   // Duplicate logos for seamless infinite scroll
//   const allLogos = [...partnerLogos, ...partnerLogos];

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         if (entry.isIntersecting) {
//           setIsVisible(true);
//           observer.unobserve(entry.target);
//         }
//       },
//       { threshold: 0.3 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//     };
//   }, []);

//   return (
//     <section 
//       id="our-partners" 
//       ref={sectionRef}
//       className={`partners-section ${isVisible ? 'visible' : ''}`}
//     >
//     <div className="help p-0 m-0" style={{ paddingBottom: '20px' }}>
//       <h2 className="title-animation">
//         Our Partners
//       </h2>
//     </div>


//       <div className="partners-carousel">
//         <div className="partners-track">
//           {allLogos.map((logo, index) => (
//             <div key={index} className="partner-card">
//               <img 
//                 src={logo.src} 
//                 alt={logo.alt}
//                 loading="lazy"
//               />
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Partners;